import IsLoading from "@/components/layouts/IsLoading";
import TrialContext from "@/contexts/data/TrialContext";
import useTrialStatuses from "@/hooks/data/useTrialStatuses";
import { Alert, AlertTitle, Box, Chip, Divider, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Table, TableBody, TableCell, TableHead, TableRow, TextField, Theme, Tooltip, TooltipProps, Typography, darken, lighten, styled, tooltipClasses, useTheme } from "@mui/material";
import { FC, Fragment, ReactNode, useCallback, useContext, useMemo } from "react";
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Link, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboardList, faCommentAlt, faCommentCaptions, faExclamationCircle, faFileCheck, faFileMagnifyingGlass } from "@fortawesome/pro-duotone-svg-icons";
import { green, grey, red, yellow } from "@mui/material/colors";
import useParticipants from "@/hooks/data/useParticipants";
import useParticipantStatuses from "@/hooks/data/useParticipantStatuses";
import InstitutionContext from "@/contexts/data/InstitutionContext";
import Show from "@/components/layouts/Show";
import { AppSettings } from "@/AppSettings";
import { CoordinatingGroup, Institution, MasterGroup, Participant, UpdateStatusEvent } from "@/api/dtos";
import { DefaultSortableFields, IStatusListSortable } from "@/components/lists/status/StatusListSort";
import { DateTime } from 'luxon';
import InstitutionsContext from "@/contexts/data/InstitutionsContext";
import SetLinks from "@/components/layouts/SetLinks";
import { ParticipantInstitutionCreateLink, ParticipantTrialCreateLink } from "@/contexts/layouts/LinkContext";
import useStatusUpdate from "@/hooks/data/useStatusUpdate";
import MasterGroupsContext from "@/contexts/data/MasterGroupsContext";
import CoordinatingGroupsContext from "@/contexts/data/CoordinatingGroupsContext";
import ParticipantsContext from "@/contexts/data/ParticipantsContext";
import Text, { ITextProps } from "@/components/forms/inputs/Text";
import Multiselect, { IMultiselectProps } from "@/components/forms/inputs/Multiselect";
import ParticipantStatusList from "@/components/lists/status/ParticipantStatusList";

const StatBox = styled(Box)(({ theme }) => ({ 
    display: 'flex',
    alignItems: 'center',
    width: '120px',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    background: theme.palette.mode === 'dark' ? darken(theme.palette.primary.main,0.5) : lighten(theme.palette.primary.main, 0.5)
}));

const InstBox = styled(Box)(({ theme }) => ({ 
    display: 'flex',
    alignItems: 'center',
    width: '120px',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    background: theme.palette.mode === 'dark' ? darken(theme.palette.secondary.main,0.5) : lighten(theme.palette.secondary.main, 0.5)
}));

const Participants: FC = () => {
    const { data: trial } = useContext(TrialContext);
    const { data: participants } = useContext(ParticipantsContext);
    const { idMap: statusMapping, loading: statusesLoading, validating: statusesValidating, refresh: statusesRefresh } = useParticipantStatuses(trial?.id);


    const updateStatuses = useCallback(async (event: UpdateStatusEvent) => {
        if (event.trialId == trial?.id) {
            await statusesRefresh()
        }
    }, [statusesRefresh, trial]);

    const {processing, queueUpdate, error} = useStatusUpdate(
        updateStatuses,
        updateStatuses
    );

    const queueStatusUpdate = useCallback(async (item: Participant) => {
        await queueUpdate({ participantId: item.id });
        await statusesRefresh();
    }, [queueUpdate, statusesRefresh])

    const loading = statusesLoading;
    const validating = statusesValidating || processing;

    return (
        <>
            <SetLinks createTrialLink={ParticipantTrialCreateLink} createInstitutionLink={ParticipantInstitutionCreateLink} />
            <IsLoading name="participants-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Participants
                </Typography>
                <ParticipantStatusList 
                    data={participants}
                    statuses={statusMapping}
                    queueUpdate={queueStatusUpdate}
                />
                {/* <StatusList 
                    data={participantData}
                    sortKey="participants"
                    sortableFields={SortableFields}
                    searchFields={SearchableFields}
                    participants={false}
                    StatComponent={ParticipantStats}
                    noRecords={
                        <Alert
                            icon={<FontAwesomeIcon icon={faExclamationCircle} />}
                            severity="warning"
                        >
                            <AlertTitle>No Participants</AlertTitle>
                            No participants were found on the {trial?.name} trial {(institution ? `at ${institution.name}` : undefined)}.
                        </Alert>
                    }
                    onUpdateStatus={queueStatusUpdate}
                /> */}
            </Show>
        </>
    )
};

export default Participants;